import { render, staticRenderFns } from "./AssignedAgents.vue?vue&type=template&id=6ad12781&"
import script from "./AssignedAgents.vue?vue&type=script&lang=js&"
export * from "./AssignedAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports